import { IModalDescription, IModalManager, IModalProps, LayoutConfig, ModalIdentifier } from '@cp/shared/modal';
import { RefObject } from 'react';

export class RefModalManager implements IModalManager {
  #ref: RefObject<IModalManager> | null = null;

  connect(ref: RefObject<IModalManager>) {
    this.#ref = ref;
  }
  disconnect() {
    this.#ref = null;
  }

  open<M extends IModalDescription<P>, P extends IModalProps<Parameters<P['onSuccess']>[0]>>(
    modal: M,
    props: P,
    parent?: ModalIdentifier,
    layout?: LayoutConfig,
  ) {
    if (!this.#ref?.current) {
      throw new Error('Modal manager is not connected');
    }
    return this.#ref.current.open(modal, props, parent, layout);
  }
  close(uniqId: ModalIdentifier) {
    if (!this.#ref?.current) {
      throw new Error('Modal manager is not connected');
    }
    return this.#ref.current.close(uniqId);
  }
}
